// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"app__page-wrapper___9hhzc","dropdown-wrapper":"app__dropdown-wrapper___3yuZt","middle":"app__middle___cwUcf"};